import Library from './library/components';
import Subcategory from './subcategory/components';
import MyList from './my-list/components';
import ContinueSeries from './continue-series/components';
import MyWorkouts from './my-workouts/components';
import MyChallenges from './my-challenges/components';
import Category from './category/components';
import Programs from './programs/components';
import Search from './search/components';
import TrainerProfile from './trainer-profile/';
import Trainers from './trainers/components';
import TrophyCase from './trophy-case/components';
import Favorites from './favorites/components';
import Query from './query/components';

export interface IRoute {
  path: string;
  component: React.ComponentType;
}

export type WithCategorySlug = {
  categorySlug: string;
  subcategorySlug?: string;
};

export type WithQuerySlug = {
  querySlug: string;
};

export enum TrophyTabs {
  milestones = 'milestones',
  // liveEvents = 'live-events',
  challenges = 'challenges',
}
export type WithTrophySlug = {
  trophySlug: TrophyTabs;
};

export type ProgramsParams = WithCategorySlug;

export type CategoryParams = WithCategorySlug;

export type QueryParams = WithQuerySlug;

const routes: IRoute[] = [
  {
    path: '/category/:categorySlug/:subcategorySlug',
    component: Subcategory,
  },
  { path: '/category/:categorySlug', component: Category },
  { path: '/programs/:categorySlug', component: Programs },
  { path: '/programs', component: Programs },
  { path: '/challenges', component: MyChallenges },
  { path: '/my-challenges', component: MyChallenges },
  { path: '/favorites', component: Favorites },
  { path: '/my-list', component: MyList },
  { path: '/continue-series', component: ContinueSeries },
  { path: '/my-workouts', component: MyWorkouts },
  { path: '/search', component: Search },
  { path: '/trainers', component: Trainers },
  { path: '/trophy-case/:trophySlug?', component: TrophyCase },
  { path: '/query/:querySlug', component: Query },
  { path: '/trainer/:trainerId', component: TrainerProfile },
  { path: '/', component: Library },
];

export default routes;
